var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.themeVariables.settings.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
// The popup owns its selections and hidden cart inputs. Gifts are managed by EasyGift.
(function () {
  'use strict';
  function init() {
    var root = document.querySelector('#custom-section');
    if (!root || root.dataset.tfbReady) return;
    root.dataset.tfbReady = 'true';
    var basePrice = Number(root.dataset.basePrice) || 0;
    var baseCompare = Number(root.dataset.baseCompare) || basePrice;
    var variantId = root.dataset.variantId;
    var automatic = new Set();
    var quoteController;
    var quoteVersion = 0;
    var selectedBeforeRerender = new Set();
    var euro = new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR', maximumFractionDigits: 0});
    var premiumEuro = new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR', minimumFractionDigits: 2});
    var money = function (cents) { return euro.format(cents / 100).replace(/\s/g, ''); };
    var inputs = function () { return Array.from(root.querySelectorAll('input[name="upsell_lock"]')); };
    var role = function (name) { return inputs().filter(function (el) { return el.dataset.insuranceRole === name && !el.disabled; }); };
    var panel = function () { return root.querySelector('[data-insurance-panel]'); };
    var request = function () { return role('request')[0]; };
    function message(text) {
      var node = root.querySelector('[data-insurance-message]');
      if (node) node.textContent = text || '';
    }
    function invalidateQuote() {
      quoteVersion++;
      if (quoteController) quoteController.abort();
      var area = panel();
      if (!area) return;
      var result = area.querySelector('[data-quote-result]');
      var status = area.querySelector('[data-quote-status]');
      var button = area.querySelector('[data-calculate-premium]');
      if (result) result.hidden = true;
      if (status) status.textContent = '';
      if (button) { button.disabled = false; button.textContent = area.dataset.idle; }
    }
    function removeAutomatic(except) {
      inputs().forEach(function (el) {
        if (automatic.has(el.value) && el !== except) el.checked = false;
      });
      automatic.clear();
    }
    function ensureRequired() {
      var missing = false;
      ['lock', 'tracker'].forEach(function (name) {
        var choices = role(name);
        if (choices.some(function (el) { return el.checked; })) return;
        choices.sort(function (a, b) { return Number(a.dataset.price) - Number(b.dataset.price); });
        var choice = choices[0];
        if (!choice) { missing = true; return; }
        choice.checked = true;
        automatic.add(choice.value);
      });
      if (missing) {
        if (request()) request().checked = false;
        removeAutomatic();
        message(panel() ? panel().dataset.missing : '');
      }
    }
    function selectedRows() {
      var area = panel();
      if (!area) return;
      var selected = request() && request().checked;
      area.hidden = !selected;
      var rows = area.querySelector('[data-insurance-selected]');
      rows.replaceChildren();
      if (!selected) return;
      inputs().filter(function (el) { return el.checked && ['lock', 'tracker'].includes(el.dataset.insuranceRole); }).forEach(function (el) {
        var row = document.createElement('div');
        if (el.dataset.image) {
          var image = document.createElement('img');
          image.src = el.dataset.image; image.alt = ''; image.width = 44; image.height = 44;
          row.append(image);
        }
        var title = document.createElement('span');
        title.textContent = area.dataset.selected + ' ' + el.dataset.title;
        var price = document.createElement('strong');
        price.textContent = money(Number(el.dataset.price));
        row.append(title, price); rows.append(row);
      });
    }
    function sync() {
      var total = basePrice;
      var compare = Math.max(basePrice, baseCompare);
      var selected = new Map();
      inputs().forEach(function (el) { if (el.checked && !el.disabled) selected.set(el.value, el); });
      selected.forEach(function (el) {
        var price = Number(el.dataset.price) || 0;
        total += price; compare += Math.max(price, Number(el.dataset.comparePrice) || 0);
      });
      var sale = root.querySelector('price-list sale-price');
      var regular = root.querySelector('price-list compare-at-price');
      if (sale) sale.textContent = money(total);
      if (regular) { regular.textContent = money(compare); regular.hidden = compare <= total; }
      root.dataset.totalCents = String(total);
      var container = root.querySelector('.hidden-items');
      if (container) {
        container.replaceChildren();
        var index = 1;
        selected.forEach(function (el) {
          var id = document.createElement('input');
          id.type = 'hidden'; id.name = 'items[' + index + '][id]'; id.value = el.value;
          var quantity = document.createElement('input');
          quantity.type = 'hidden'; quantity.name = 'items[' + index + '][quantity]'; quantity.value = '1';
          container.append(id, quantity); index++;
        });
      }
      selectedRows();
    }
    root.addEventListener('change', function (event) {
      var el = event.target;
      if (!el.matches('input[name="upsell_lock"]')) return;
      invalidateQuote(); message('');
      var insurance = request();
      if (el === insurance) {
        if (el.checked) ensureRequired(); else removeAutomatic();
      } else {
        automatic.delete(el.value); // A customer's own choice is never silently removed later.
        if (insurance && insurance.checked) {
          if (el.checked && el.dataset.insuranceRole === 'lock') {
            role('lock').forEach(function (lock) {
              if (lock !== el && automatic.has(lock.value)) { lock.checked = false; automatic.delete(lock.value); }
            });
          }
          var ready = ['lock', 'tracker'].every(function (name) { return role(name).some(function (item) { return item.checked; }); });
          if (!ready) {
            insurance.checked = false;
            removeAutomatic(el);
            message(panel() ? panel().dataset.missing : '');
          }
        }
      }
      sync();
    });
    root.addEventListener('input', function (event) { if (event.target.matches('[data-insurance-postcode]')) invalidateQuote(); });
    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-change-lock]')) {
        var lock = role('lock').find(function (el) { return el.checked; }) || role('lock')[0];
        if (lock) { lock.closest('.upsell-locks').scrollIntoView({behavior: 'smooth', block: 'start'}); lock.focus({preventScroll: true}); }
      }
      if (event.target.closest('[data-calculate-premium]')) calculate();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.matches('[data-insurance-postcode]')) { event.preventDefault(); calculate(); }
    });
    async function calculate() {
      var area = panel();
      if (!area || !request() || !request().checked) return;
      var field = area.querySelector('[data-insurance-postcode]');
      if (!field) return;
      invalidateQuote();
      var postcode = field.value.replace(/\s/g, '').toUpperCase();
      var status = area.querySelector('[data-quote-status]');
      field.removeAttribute('aria-invalid');
      if (!/^[1-9][0-9]{3}[A-Z]{2}$/.test(postcode)) {
        status.textContent = area.dataset.postcodeError; field.setAttribute('aria-invalid', 'true'); field.focus(); return;
      }
      field.value = postcode.slice(0, 4) + ' ' + postcode.slice(4);
      // Restrict configuration to Shopify's same-origin proxy. Partner secrets never reach the browser.
      if (!/^\/apps\/[a-zA-Z0-9/_-]+$/.test(area.dataset.quoteEndpoint)) { status.textContent = area.dataset.error; return; }
      var version = quoteVersion;
      var button = area.querySelector('[data-calculate-premium]');
      button.disabled = true; button.textContent = area.dataset.loading;
      quoteController = new AbortController();
      var controller = quoteController;
      var timeout = setTimeout(function () { controller.abort(); }, 15000);
      try {
        var response = await fetch(area.dataset.quoteEndpoint, {
          method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          credentials: 'same-origin', signal: controller.signal,
          body: JSON.stringify({postcode: postcode, country: 'NL', productId: area.dataset.productId, variantId: String(variantId), accessoryVariantIds: inputs().filter(function (el) { return el.checked && !el.disabled && el.dataset.insuranceRole !== 'request'; }).map(function (el) { return el.value; })})
        });
        var data = await response.json();
        if (version !== quoteVersion) return;
        if (!response.ok || data.success !== true || !Number.isSafeInteger(data.monthlyPremiumCents) || data.monthlyPremiumCents <= 0 || data.currency !== 'EUR' || !data.coverageLabel || !data.costSummary || data.postcode !== postcode || data.variantId !== String(variantId)) throw new Error('Invalid quote');
        // monthlyPremiumCents is converted to euros below; purchase totals remain integer cents.
        area.querySelector('[data-quote-premium]').textContent = premiumEuro.format(data.monthlyPremiumCents / 100).replace(/\s/g, '') + ' ' + area.dataset.perMonth;
        area.querySelector('[data-quote-coverage]').textContent = data.coverageLabel;
        area.querySelector('[data-quote-detail]').textContent = data.costSummary;
        area.querySelector('[data-quote-result]').hidden = false;
      } catch (error) {
        if (version === quoteVersion) status.textContent = area.dataset.error;
      } finally {
        clearTimeout(timeout);
        if (version === quoteVersion) { button.disabled = false; button.textContent = area.dataset.idle; }
      }
    }
    root.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      invalidateQuote();
      if (variant) { variantId = String(variant.id); basePrice = Number(variant.price); baseCompare = Number(variant.compare_at_price) || basePrice; window.selected_variant = variant; }
      sync();
    });
    root.addEventListener('product:rerender', function () {
      selectedBeforeRerender = new Set(inputs().filter(function (el) { return el.checked; }).map(function (el) { return el.value; }));
      setTimeout(function () { inputs().forEach(function (el) { el.checked = selectedBeforeRerender.has(el.value) && !el.disabled; }); sync(); }, 0);
    }, true);
    root.addEventListener('submit', function () { sync(); }, true);
    sync();
    $(document).on('click', '.post-selection__atc-btn', function (event) {
      event.preventDefault(); sync(); $(root).addClass('is-open').css('display', 'flex'); $('body').addClass('popup-open');
    });
    function closePopup() { $(root).removeClass('is-open').fadeOut('fast'); $('body').removeClass('popup-open'); }
    $(document).on('click', '.popup-close', function (event) { event.preventDefault(); closePopup(); });
    root.addEventListener('click', function (event) { if (event.target === root) closePopup(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && root.classList.contains('is-open')) closePopup(); });
    root.addEventListener('cart:change', closePopup);
    $(document).on('submit', '#custom-section [is="product-form"]', function () { setTimeout(closePopup, 1000); });
  }
  $(init);
  document.addEventListener('shopify:section:load', init);
})();
